/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ChallengeFaqDetails,
    ChallengeFaqDetailsFromJSON,
    ChallengeFaqDetailsFromJSONTyped,
    ChallengeFaqDetailsToJSON,
    ChallengeInfoResponseAllOf,
    ChallengeInfoResponseAllOfFromJSON,
    ChallengeInfoResponseAllOfFromJSONTyped,
    ChallengeInfoResponseAllOfToJSON,
    ChallengeInstantReward,
    ChallengeInstantRewardFromJSON,
    ChallengeInstantRewardFromJSONTyped,
    ChallengeInstantRewardToJSON,
    ChallengeMembership,
    ChallengeMembershipFromJSON,
    ChallengeMembershipFromJSONTyped,
    ChallengeMembershipToJSON,
    ChallengeOnboarding,
    ChallengeOnboardingFromJSON,
    ChallengeOnboardingFromJSONTyped,
    ChallengeOnboardingToJSON,
    ChallengeResponse,
    ChallengeResponseFromJSON,
    ChallengeResponseFromJSONTyped,
    ChallengeResponseToJSON,
    OWGameResponse,
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    PrizePool,
    PrizePoolFromJSON,
    PrizePoolFromJSONTyped,
    PrizePoolToJSON,
    QuestConfig,
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
    QuestProgression,
    QuestProgressionFromJSON,
    QuestProgressionFromJSONTyped,
    QuestProgressionToJSON,
    RewardConfigResponse,
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ChallengeInfoResponse
 */
export interface ChallengeInfoResponse extends ChallengeResponse {
    /**
     * Whether the challenge has been accepted by the user only if the user is logged in.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    isAccepted?: boolean;
    /**
     * 
     * @type {Array<PrizePool>}
     * @memberof ChallengeInfoResponse
     */
    prizes: Array<PrizePool>;
    /**
     * 
     * @type {Array<ChallengeMembership>}
     * @memberof ChallengeInfoResponse
     */
    winners?: Array<ChallengeMembership>;
    /**
     * The slug of the brand map associated with this challenge.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandMapSlug?: string;
    /**
     * 
     * @type {ChallengeInstantReward}
     * @memberof ChallengeInfoResponse
     */
    instantReward?: ChallengeInstantReward;
    /**
     * Whether user dismissed the challenge completed feedback.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    dismissedCompleteFeedBack?: boolean;
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof ChallengeInfoResponse
     */
    games?: Array<OWGameResponse>;
    /**
     * 
     * @type {Array<QuestConfig>}
     * @memberof ChallengeInfoResponse
     */
    quests?: Array<QuestConfig>;
    /**
     * 
     * @type {Array<QuestProgression>}
     * @memberof ChallengeInfoResponse
     */
    progressions?: Array<QuestProgression>;
}

export function ChallengeInfoResponseFromJSON(json: any): ChallengeInfoResponse {
    return ChallengeInfoResponseFromJSONTyped(json, false);
}

export function ChallengeInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ChallengeResponseFromJSONTyped(json, ignoreDiscriminator),
        'isAccepted': !exists(json, 'isAccepted') ? undefined : json['isAccepted'],
        'prizes': ((json['prizes'] as Array<any>).map(PrizePoolFromJSON)),
        'winners': !exists(json, 'winners') ? undefined : ((json['winners'] as Array<any>).map(ChallengeMembershipFromJSON)),
        'brandMapSlug': !exists(json, 'brandMapSlug') ? undefined : json['brandMapSlug'],
        'instantReward': !exists(json, 'instantReward') ? undefined : ChallengeInstantRewardFromJSON(json['instantReward']),
        'dismissedCompleteFeedBack': !exists(json, 'dismissedCompleteFeedBack') ? undefined : json['dismissedCompleteFeedBack'],
        'games': !exists(json, 'games') ? undefined : ((json['games'] as Array<any>).map(OWGameResponseFromJSON)),
        'quests': !exists(json, 'quests') ? undefined : ((json['quests'] as Array<any>).map(QuestConfigFromJSON)),
        'progressions': !exists(json, 'progressions') ? undefined : ((json['progressions'] as Array<any>).map(QuestProgressionFromJSON)),
    };
}

export function ChallengeInfoResponseToJSON(value?: ChallengeInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ChallengeResponseToJSON(value),
        'isAccepted': value.isAccepted,
        'prizes': ((value.prizes as Array<any>).map(PrizePoolToJSON)),
        'winners': value.winners === undefined ? undefined : ((value.winners as Array<any>).map(ChallengeMembershipToJSON)),
        'brandMapSlug': value.brandMapSlug,
        'instantReward': ChallengeInstantRewardToJSON(value.instantReward),
        'dismissedCompleteFeedBack': value.dismissedCompleteFeedBack,
        'games': value.games === undefined ? undefined : ((value.games as Array<any>).map(OWGameResponseToJSON)),
        'quests': value.quests === undefined ? undefined : ((value.quests as Array<any>).map(QuestConfigToJSON)),
        'progressions': value.progressions === undefined ? undefined : ((value.progressions as Array<any>).map(QuestProgressionToJSON)),
    };
}


